module.exports = {
  "/": {
    "name": "manage-redirect",
    "success": {
      "default": [
        "MANAGE_REDIRECT"
      ]
    }
  },
  "/manage": {
    "name": "manage-redirect",
    "success": {
      "default": [
        "MANAGE_REDIRECT"
      ]
    }
  },
  "/manage/state/:state": {
    "success": {
      "manage page loaded": [
        "MANAGE_PAGE_RENDERED"
      ],
      "table success state": [
        "TABLE_SUCCESS_STATE"
      ],
      "prohibited page loaded": [
        "PROHIBITED_PAGE_CONTAINER"
      ]
    },
    "error": [
      "ASYNC_COMPONENT_FAILED_TO_LOAD",
      "ERROR_PAGE_RENDERED",
      "TABLE_ERROR_STATE"
    ]
  },
  "/analyze": {
    "success": {
      "analyze page loaded": [
        "ANALYZE_PAGE_RENDERED",
        "ENGAGEMENT_REPORT_SUCCEEDED",
        "CLICKS_OVER_VIEWS_REPORT_SUCCEEDED"
      ],
      "prohibited page loaded": [
        "PROHIBITED_PAGE_CONTAINER"
      ]
    },
    "error": [
      "ASYNC_COMPONENT_FAILED_TO_LOAD",
      "ERROR_PAGE_RENDERED",
      "ENGAGEMENT_REPORT_FAILED",
      "CLICKS_OVER_VIEWS_REPORT_FAILED"
    ]
  },
  "/details/:identifier": {
    "success": {
      "interactive details page loaded": [
        "DETAILS_PAGE_RENDERED"
      ],
      "prohibited page loaded": [
        "PROHIBITED_PAGE_CONTAINER"
      ]
    },
    "error": [
      "ASYNC_COMPONENT_FAILED_TO_LOAD",
      "ERROR_PAGE_RENDERED"
    ]
  },
  "/details/:identifier/performance": {
    "success": {
      "interactive details page loaded": [
        "DETAILS_PAGE_RENDERED",
        "DETAILS_DATA_SUCCEEDED",
        "ENGAGEMENT_REPORT_SUCCEEDED",
        "CLICKS_OVER_VIEWS_REPORT_SUCCEEDED"
      ],
      "prohibited page loaded": [
        "PROHIBITED_PAGE_CONTAINER"
      ]
    },
    "error": [
      "ASYNC_COMPONENT_FAILED_TO_LOAD",
      "ERROR_PAGE_RENDERED",
      "DETAILS_DATA_FAILED",
      "CLICKS_OVER_VIEWS_REPORT_FAILED",
      "ENGAGEMENT_REPORT_FAILED"
    ]
  },
  "/details/:identifier/forms": {
    "success": {
      "interactive form submissions loaded": [
        "DETAILS_PAGE_RENDERED",
        "FORMS_EMPTY_LOADED"
      ],
      "interactive form submissions page no results": [
        "DETAILS_PAGE_RENDERED",
        "FORMS_EMPTY_LOADED"
      ],
      "prohibited page loaded": [
        "PROHIBITED_PAGE_CONTAINER"
      ]
    },
    "error": [
      "ASYNC_COMPONENT_FAILED_TO_LOAD",
      "ERROR_PAGE_RENDERED",
      "ERROR_LOADING_FORMS"
    ]
  },
  "/create": {
    "success": {
      "create page loaded": [
        "CREATE_PAGE_RENDERED",
        "TEMPLATES_LOADED"
      ],
      "prohibited page loaded": [
        "PROHIBITED_PAGE_CONTAINER"
      ]
    },
    "error": [
      "TEMPLATES_FAILED",
      "ASYNC_COMPONENT_FAILED_TO_LOAD",
      "ERROR_PAGE_RENDERED"
    ]
  }
};